module.exports = __webpack_public_path__ + "img/GoPrVoucher@2x.c316fb29.png";